import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchPageContent } from '@client/connectivity/api.cms';
import { loadEvents } from '@client/redux/event/eventReducer';
import { loadFundraiserTypes } from '@client/redux/fundraiser/fundraiserActions';

export const DUCK_CREATE_IF_PAGE_KEY = 'duckCreateIfPageReducer';

const SET_CREATE_IF_PAGE_ERROR = 'SET_CREATE_IF_PAGE_ERROR';
const LOAD_CREATE_IF_PAGE_CMS = 'LOAD_CREATE_IF_PAGE_CMS';

/* REDUCER */
let defaultState = fromJS({
  pageData: {},
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_CREATE_IF_PAGE_CMS: {
      return state.merge({
        pageData: fromJS(action.payload),
        errorMessage: '',
      });
    }
    case SET_CREATE_IF_PAGE_ERROR: {
      return state.merge({
        errorMessage: action.payload,
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */
export function loadCreateIfPageCms() {
  return function (dispatch) {
    return fetchPageContent('createIfPage').then((response) => {
      return dispatch({
        type: LOAD_CREATE_IF_PAGE_CMS,
        payload: response,
      });
    });
  };
}

export function loadCreateIfPageData() {
  return function (dispatch) {
    const dataPromises = [
      dispatch(loadCreateIfPageCms()),
      dispatch(loadEvents()),
      dispatch(loadFundraiserTypes()),
    ];

    return Promise.all(dataPromises);
  };
}

/* SELECTORS */
export const selectCreateIfPageData = (state) => {
  return valIn(state[DUCK_CREATE_IF_PAGE_KEY], 'pageData');
};
